import React, { useCallback, useEffect, useRef, useState } from 'react'
import { StyleSheet } from 'react-native'

import { Stack } from '@zet/design-system'

import { useAutoComplete } from '../../../api/autoComplete/hooks/useAutoComplete'
import { useApiAction } from '../../../api/useApiAction'
import SelectDropDown from '../selectDropDown'
import TextInput from '../textInput'

interface Props {
  label: string
  placeholder: string
  onChange: (arg: any) => void
  onBlur: () => void
  value: string
  errorMessage: string
  isRequired: boolean
  dropdownMode: string
  isSearchable: boolean
  searchEndPoint: string
  options: any
  fieldId: string
  ocFieldCode: string
  data: {
    state: string
    city: string
  }
  autoCompleteLength?: number
}

export default function PincodeSelector({
  label = 'Select Dropdown',
  placeholder = 'Select',
  onChange,
  onBlur,
  value,
  errorMessage,
  isRequired = true,
  dropdownMode = 'single',
  isSearchable = false,
  searchEndPoint,
  options,
  fieldId,
  ocFieldCode,
  data,
  autoCompleteLength = 3,
}: Props) {
  const dropDownRef = useRef<any>(null)
  const [selectedPincodeData, setSelectedPincodeData] = useState<any>(data)
  const { data: list } = useApiAction({ skipInitFetch: true })
  const { data: pincodeData, refetch: getAutoComplete } = useAutoComplete(
    value,
    fieldId,
    ocFieldCode,
    '',
    list?.metadata?.leadId ?? ''
  )

  useEffect(() => {
    const data: any = dropDownRef?.current?.getFieldValue(value)
    if (data) {
      setSelectedPincodeData(data?.data)
    } else if (value?.length) {
      setCityState()
    }
  }, [value])

  const setCityState = useCallback(async () => {
    try {
      const response = await getAutoComplete()
      const select = response.data?.results.find((item: any) => {
        return item.optionId === value
      })
      setSelectedPincodeData(select?.data)
    } catch (error) {}
  }, [])

  return (
    <Stack>
      <SelectDropDown
        ref={dropDownRef}
        label={label}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        isRequired={isRequired}
        dropdownMode={dropdownMode}
        isSearchable={isSearchable}
        errorMessage={errorMessage}
        searchEndPoint={searchEndPoint}
        options={options}
        fieldId={fieldId}
        ocFieldCode={ocFieldCode}
        autoCompleteLength={autoCompleteLength}
      />
      <TextInput
        value={selectedPincodeData?.city}
        placeholder={'Select City'}
        disabled
        style={styles.textInput}
      />
      <TextInput
        value={selectedPincodeData?.state}
        placeholder={'Select State'}
        disabled
        style={styles.textInput}
      />
    </Stack>
  )
}

const styles = StyleSheet.create({
  textInput: {
    marginTop: 8,
  },
})
